
        import 'CapturePlanDetails.be0897e.css-module'
        export default {"planDetails":"planDetails_CapturePlanDetails_be0897e","planDocLinks":"planDocLinks_CapturePlanDetails_be0897e"}
    